import { Paragraph } from 'components';
import { FC, useState } from 'react';
import { usePopper } from 'react-popper';

import { InfoPopup } from '../StaleInfo/StaleInfo.styles';

export interface TooltipProps {
  text: string;
  disabled?: boolean;
  placement?: 'top' | 'bottom' | 'right' | 'left';
}

const StaleTooltip: FC<TooltipProps> = ({
  text,
  disabled = false,
  placement = 'right',
  children,
}) => {
  const [show, setShow] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      { name: 'arrow', options: { element: arrowElement } },
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
    ],
    placement,
    strategy: 'fixed',
  });

  const onMouseEnter = () => {
    if (disabled) {
      return;
    }

    setShow(true);
  };

  const onMouseLeave = () => {
    if (disabled) {
      return;
    }

    setShow(false);
  };

  return (
    <>
      <div
        style={{ width: 'fit-content' }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        // @ts-ignore
        ref={setReferenceElement}
      >
        {children}
      </div>

      {show && (
        <InfoPopup
          // TODO: remove later, hack for clicks inside table
          className="tooltip"
          // @ts-ignore
          ref={setPopperElement}
          style={{ ...styles.popper }}
          {...attributes.popper}
        >
          <div
            className="arrow"
            // @ts-ignore
            ref={setArrowElement}
            style={styles.arrow}
            {...attributes.arrow}
          />
          <div className="wrap">
            <Paragraph color="white">{text}</Paragraph>
          </div>
        </InfoPopup>
      )}
    </>
  );
};

export default StaleTooltip;
